import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'

const ContentOne = () => {
    const location = useLocation()

    const [render, setRender] = useState<stateComponentComplete>({ ready: false})
    useEffect(() => {
        if (render.ready) sendDataLayer('onload-pager', location.pathname)
        setRender({ ready: true})
    }, [location.pathname, render.ready])
    return (
        <main className='container_content_one'>
            <section className='container_text_one'>
                <p className='paragraph'>
                    <span className='span_text'>Profuturo y Soy+</span> juntos para que disfrutes de más beneficios.<br /><br />
                    <span className='span_text'>Una suscripción</span> pensada para acompañarte con experiencias y contenidos que mejoran tu vida.
                </p>
                <div className='img_one'>
                    <img
                        src='/assets/pareja.webp'
                        alt='pareja-cenando'
                        className='img-pareja'
                    />
                    <img
                        src='/assets/CambioPareja.webp'
                        alt='pareja-mobile'
                        className='pareja-mobile'
                    />
                </div>
            </section>
        </main>
    )
}

export default ContentOne